import React from 'react';

import i18n from 'Utilities/i18n';

import SadFile from 'Images/sad-file.svg';

const PageNotFound: React.FC<React.PropsWithChildren> = () => {
  return (
    <div className="h-100 d-flex flex-column align-items-center justify-content-center">
      <div className="row">
        <img className="p-4" alt="sad-file" src={SadFile} />
      </div>
      <div className="row">
        <h1
          className="fs-2 fw-bold text-primary"
          style={{
            color: 'rgba(0, 128, 255, 1)',
            borderBottomWidth: '0.5rem',
          }}
        >
          {i18n.t('PageNotFound.title')}
        </h1>
      </div>
      <div className="row mb-1">
        <h2
          className="fs-4 border-bottom"
          style={{
            color: 'rgba(0, 0, 255, 0.5)',
          }}
        >
          {i18n.t('PageNotFound.404')}
        </h2>
      </div>
      <div
        className="row border-top pt-2 px-5"
        style={{
          borderTop: '0.1rem solid #979797',
          paddingLeft: '15rem',
          paddingRight: '15rem',
        }}
      >
        <p className="fs-6" style={{ color: 'rgba(67, 70, 75, 1)' }}>
          {i18n.t('PageNotFound.description')}
        </p>
      </div>
    </div>
  );
};

export default PageNotFound;
